import axios from 'axios'
import { AssaysViewCaseResponse } from '@/components/assays-view/services/assays-view-case/assays-view-case.dto'

class AssaysViewCaseService {
    async getAssaysView(
        laboratoryId: number,
        caseId: number
    ): Promise<AssaysViewCaseResponse> {
        const response =
            await axios.get<AssaysViewCaseResponse>(
                `/assaysView/laboratories/${laboratoryId}/cases/${caseId}/assaysview`)
        return response.data
    }
}

export const assaysViewCaseService = new AssaysViewCaseService()
